/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        class SecurityKeywordsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    
                    return new SecurityKeywordsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    
                    SecurityKeywordsWidgetInstanceClass.HtmlData = htmlData;
                    if (this.Instances != null && this.Instances.length > 0) {
                        
                        this.Instances.forEach(function (instance) {
                            instance.presentInstance();
                        });
                    }
                };
                
                // core.Loader.loadVersionedCSS('widgets/SecurityKeywords/security-keywords.min.css');
                core.Loader.getVersionedHTML('widgets/SecurityKeywords/security-keywords.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
            }
        }
        Widgets.SecurityKeywordsWidgetTypeClass = SecurityKeywordsWidgetTypeClass;
        class SecurityKeywordsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                // UI
                this._instanceSelector = null;
                this._contextBar = null;
                this._contextLabel = null;
                this._addButton = null;
                this._keyTypeSelect = null;
                this._keyTableBody = null;
                this._noRecordsHeader = null;
                this._editControls = null;
                this._applyEditsButton = null;
                this._cancelEditsButton = null;
                this._suppressContextBar = false;
                // Modal content
                this._globalModalDiv = null;
                this._modalKeyTypeSelect = null;
                this._modalOperatorCB = null;
                this._modalUserNameRB = null;
                this._modalKeyValueRB = null;
                this._modalValueEdit = null;
                // Data
                this._keywordTypes = [];
                this._localIDCounter = 1; // Array can change and has no built-in ID so move to object
                this._skDictionary = {};
                // State
                this._mode = "None";
                this._currentUser = null;
                this._currentGroup = null;
                this._currentRecordId = "";
                this._editsMade = false;
                this.presentInstance = () => {
                    
                    this._container.innerHTML = SecurityKeywordsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    // TODO: switch to core modal handling
                    this._globalModalDiv = document.querySelector('#modalPlaceholder');
                    this._contextBar = this._container.querySelector('#securityKeysContextBar');
                    this._contextLabel = this._container.querySelector('#securityKeysContextLabel');
                    this._keyTypeSelect = this._container.querySelector('#skKeyTypeSelect');
                    this._keyTableBody = this._container.querySelector('#securityKeysTableBody');
                    this._noRecordsHeader = this._container.querySelector('#securityKeysNoRecords');
                    this._addButton = this._container.querySelector('#securityKeysAddButton');
                    this._editControls = this._container.querySelector('#securityKeysEditControls');
                    this._applyEditsButton = this._container.querySelector('#securityKeysApplyEdit');
                    this._cancelEditsButton = this._container.querySelector('#securityKeysCancelEdit');
                    this._widgets.setTitle(this._config, this._container.querySelector('#securityKeysHeading'), 'STR_WPT_SECURITY_KEYWORDS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#securityKeysModifiedLabel'), 'STR_WPT_KEYWORDS_MODIFIED');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#securityKeysNoRecordsLabel'), 'STR_WPT_SEC_KEYS_NONE_SET');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#securityKeysLoading'), 'STR_WPT_LOADING');
                    this._applyEditsButton.addEventListener('click', this._applyEdits);
                    this._cancelEditsButton.addEventListener('click', this._cancelEdits);
                    this._addButton.addEventListener('click', this._addClicked);
                    let conf = this._config;
                    if (conf.hasOwnProperty('SuppressContextBar') && conf.SuppressContextBar)
                        this._suppressContextBar = true;
                    this._type.instanceReady(this.getHandle());
                    this._loadKeywordTypes();
                };
                this._callFailedHandler = (json) => {
                    
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    
                    this.addError(message);
                };
                this._loadKeywordTypes = () => {
                    
                    this._core.OBHelper.LoadKeywordTypes(this._keywordTypesLoaded);
                };
                this._keywordTypesLoaded = () => {
                    
                    this._keyTypeSelect.innerHTML = "";
                    this._keywordTypes = this._core.OBHelper.KeywordTypes;
                    let optionString = "";
                    this._keywordTypes.forEach(keyType => {
                        optionString += `<option value="${keyType.Name}">${keyType.Name}</option>`;
                    });
                    this._keyTypeSelect.innerHTML = optionString;
                };
                this.startUserMode = (userId) => {
                    
                    this._mode = "User";
                    let request = {
                        PopulateUserGroups: false,
                        PopulateSecurityKeywords: true,
                        PopulateCustomData: false
                    };
                    // We don't want a record passed over, it probably won't have the security keys populated
                    this._core.Loader.genericServiceCallWithData(`/SecurityAdmin.svc/rest/GetUserRecordById/${userId}`, JSON.stringify(request), this._userInfoReturned, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this.startGroupMode = (groupId) => {
                    this._mode = "Group";
                    let request = {
                        PopulateUsers: false,
                        PopulateSecurityKeywords: true,
                        PopulateCustomData: false
                    };
                    // We don't want a record passed over, it probably won't have the security keys populated
                    this._core.Loader.genericServiceCallWithData(`/SecurityAdmin.svc/rest/GetUserGroupRecordById/${groupId}`, JSON.stringify(request), this._groupInfoReturned, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._userInfoReturned = (response) => {
                    this._clearErrors();
                    this._skDictionary = {};
                    if (response.hasOwnProperty('UserRecord') && (response.UserRecord != null)) {
                        this._currentUser = response.UserRecord;
                        this._contextLabel.innerHTML = `${this._core.Locale.getTranslation('STR_WPT_LABEL_USER')}: ${this._currentUser.Name}`;
                        if (!this._suppressContextBar)
                            this._core.Functions.showElement(this._contextBar);
                        if (this._currentUser.hasOwnProperty('SecurityKeywords') && (this._currentUser.SecurityKeywords != null)) {
                            this._currentUser.SecurityKeywords.forEach(record => {
                                this._skDictionary[this._localIDCounter.toString()] = record;
                                this._localIDCounter++;
                            });
                        }
                    }
                    this._displayKeyList();
                };
                this._groupInfoReturned = (response) => {
                    this._clearErrors();
                    this._skDictionary = {};
                    if (response.hasOwnProperty('UserGroupRecord') && (response.UserGroupRecord != null)) {
                        this._currentGroup = response.UserGroupRecord;
                        this._contextLabel.innerHTML = `${this._core.Locale.getTranslation('STR_WPT_LABEL_GROUP')}: ${this._currentGroup.Name}`;
                        if (!this._suppressContextBar)
                            this._core.Functions.showElement(this._contextBar);
                        if (this._currentGroup.hasOwnProperty('SecurityKeywords') && (this._currentGroup.SecurityKeywords != null)) {
                            this._currentGroup.SecurityKeywords.forEach(record => {
                                this._skDictionary[this._localIDCounter.toString()] = record;
                                this._localIDCounter++;
                            });
                        }
                    }
                    this._displayKeyList();
                };
                this._displayKeyList = () => {
                    this._keyTableBody.innerHTML = "";
                    // Show/hide headers etc.
                    this._core.Functions.showElement(this._addButton);
                    if (Object.keys(this._skDictionary).length == 0)
                        this._core.Functions.showElement(this._noRecordsHeader);
                    else
                        this._core.Functions.hideElement(this._noRecordsHeader);
                    let userNameLabel = this._core.Locale.getTranslation('STR_WPT_LABEL_USER_NAME');
                    let keywordLabel = this._core.Locale.getTranslation('STR_WPT_LABEL_KEYWORD');
                    // Show actual records
                    Object.keys(this._skDictionary).forEach(recordIndex => {
                        let skRecord = this._skDictionary[recordIndex];
                        let operator = (skRecord.KeywordOperator.toLowerCase() == 'equal') ? '=' : '&ne;';
                        let target = (skRecord.ValueIsUserName) ? `&lt;&lt;${userNameLabel}&gt;&gt;` : skRecord.KeywordValue;
                        let row = this._keyTableBody.insertRow();
                        // Operator cell
                        let oCell = row.insertCell();
                        oCell.innerHTML = `<SPAN class="font20">${operator}</SPAN>`;
                        oCell.classList.add('vertical-cell');
                        // Key/value cell
                        let kCell = row.insertCell();
                        let topDiv = document.createElement('div');
                        let keySpan = document.createElement('span');
                        keySpan.innerHTML = `${keywordLabel}: ${skRecord.KeywordTypeName}`;
                        topDiv.appendChild(keySpan);
                        kCell.appendChild(topDiv);
                        let bottomDiv = document.createElement('div');
                        bottomDiv.innerHTML = `<SPAN class="font-bold">${target}</SPAN>`;
                        kCell.appendChild(bottomDiv);
                        // Buttons cell
                        let bCell = row.insertCell();
                        bCell.setAttribute('data-id', recordIndex);
                        bCell.innerHTML = `<SPAN class="wpt-font wpt-font-create font20"></SPAN>`;
                        bCell.addEventListener('click', this._editClicked);
                        bCell.classList.add('vertical-cell');
                    });
                };
                this._editClicked = (event) => {
                    let clickedItem = event.currentTarget;
                    this._currentRecordId = clickedItem.getAttribute('data-id');
                    
                    // Get our record
                    let currentRecord = this._skDictionary[this._currentRecordId];
                    // Set up modal placeholder - note we don't cache the HTML as some is populated after initialisation
                    this._globalModalDiv.innerHTML = this._container.querySelector("#securityKeysEditModalContent").innerHTML;
                    // General setup
                    this._modalKeyTypeSelect = this._globalModalDiv.querySelector('#skKeyTypeSelect');
                    for (let i = 0; i < this._modalKeyTypeSelect.options.length; i++) {
                        if (this._modalKeyTypeSelect.options[i].value == currentRecord.KeywordTypeName) {
                            this._modalKeyTypeSelect.options[i].selected = true;
                            break;
                        }
                    }
                    this._modalOperatorCB = this._globalModalDiv.querySelector('#skEqualityCheckbox');
                    this._modalOperatorCB.checked = (currentRecord.KeywordOperator.toLowerCase() == 'notequal');
                    this._modalUserNameRB = this._globalModalDiv.querySelector('#skRBEqualUserName');
                    this._modalKeyValueRB = this._globalModalDiv.querySelector('#skRBEqualValue');
                    this._modalValueEdit = this._globalModalDiv.querySelector('#skKeyValueInput');
                    if (currentRecord.ValueIsUserName) {
                        this._modalUserNameRB.checked = true;
                    }
                    else {
                        this._modalKeyValueRB.checked = true;
                        this._modalValueEdit.value = currentRecord.KeywordValue;
                    }
                    // Translations
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skEditDialogHeading'), 'STR_WPT_EDIT_SEC_KEYS');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skKeyTypeLabel'), 'STR_WPT_LABEL_KEYWORD_TYPE');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skEqualLabel'), 'STR_WPT_LABEL_EQUALTO');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skNotEqualLabel'), 'STR_WPT_LABEL_NOTEQUALTO');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skUserNameLabel'), 'STR_WPT_LABEL_USER_NAME');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skEditDelete'), 'STR_WPT_DELETE');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skEditCancel'), 'STR_WPT_CANCEL');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#skEditOK'), 'STR_WPT_LABEL_OK');
                    this._globalModalDiv.querySelector('#skKeyValueLabel').innerHTML = `${this._core.Locale.getTranslation('STR_WPT_LABEL_VALUE')}:&nbsp;`;
                    // Event handling
                    this._globalModalDiv.querySelector('#skEditOK').addEventListener('click', this._editOK);
                    this._globalModalDiv.querySelector('#skEditCancel').addEventListener('click', this._editCancel);
                    this._globalModalDiv.querySelector('#skEditDelete').addEventListener('click', this._editDelete);
                    this._core.Functions.showElement(this._globalModalDiv.querySelector('#skEditDelete'));
                    $(document).on('hidden.bs.modal', '#modalPlaceholder', this._editDialogClosed);
                    $('#modalPlaceholder').modal('show');
                };
                this._addClicked = (event) => {
                    
                    // Set up modal placeholder - note we don't cache the HTML as some is populated after initialisation
                    this._globalModalDiv.innerHTML = this._container.querySelector("#securityKeysEditModalContent").innerHTML;
                    // General setup
                    this._modalKeyTypeSelect = this._globalModalDiv.querySelector('#skKeyTypeSelect');
                    //this._modalKeyTypeSelect.options[0].selected = true;
                    this._modalOperatorCB = this._globalModalDiv.querySelector('#skEqualityCheckbox');
                    this._modalUserNameRB = this._globalModalDiv.querySelector('#skRBEqualUserName');
                    this._modalKeyValueRB = this._globalModalDiv.querySelector('#skRBEqualValue');
                    this._modalValueEdit = this._globalModalDiv.querySelector('#skKeyValueInput');
                    this._modalUserNameRB.checked = true;
                    // Event handling
                    this._globalModalDiv.querySelector('#skEditOK').addEventListener('click', this._addOK);
                    this._globalModalDiv.querySelector('#skEditCancel').addEventListener('click', this._editCancel);
                    $(document).on('hidden.bs.modal', '#modalPlaceholder', this._editDialogClosed);
                    $('#modalPlaceholder').modal('show');
                };
                this._editOK = (event) => {
                    
                    // Get our record
                    let currentRecord = this._skDictionary[this._currentRecordId];
                    // Look for differences, only stash on a change
                    let changed = false;
                    if (this._modalKeyTypeSelect.value != currentRecord.KeywordTypeName)
                        changed = true;
                    let operator = (this._modalOperatorCB.checked) ? 'notequal' : 'equal';
                    if (operator != currentRecord.KeywordOperator.toLowerCase())
                        changed = true;
                    if (this._modalUserNameRB.checked && (!currentRecord.ValueIsUserName))
                        changed = true;
                    // This should wors as null and "" are both falsy
                    if (this._modalValueEdit.value != currentRecord.KeywordValue)
                        changed = true;
                    if (changed) {
                        currentRecord.KeywordTypeName = this._modalKeyTypeSelect.value;
                        currentRecord.KeywordOperator = (this._modalOperatorCB.checked) ? 'notequal' : 'equal';
                        currentRecord.ValueIsUserName = this._modalUserNameRB.checked;
                        currentRecord.KeywordValue = currentRecord.ValueIsUserName ? null : this._modalValueEdit.value;
                        this._editsMade = true;
                    }
                    else {
                        this._currentRecordId = null;
                    }
                    $('#modalPlaceholder').modal('hide');
                };
                this._addOK = (event) => {
                    
                    // Make sure all input is valid
                    let valid = true;
                    let message = '';
                    if (this._modalKeyTypeSelect.value == '') {
                        valid = false;
                        message = 'A keyword type must be selected.';
                    }
                    else if (this._modalKeyValueRB.checked && (this._modalValueEdit.value == '')) {
                        valid = false;
                        message = 'A keyword value or user name must be selected.';
                    }
                    if (!valid) {
                        this._core.Helper.presentWarningModal(message);
                    }
                    else {
                        let ktName = this._modalKeyTypeSelect.value;
                        let ktOperator = (this._modalOperatorCB.checked) ? 'notequal' : 'equal';
                        let ktIsUser = this._modalUserNameRB.checked;
                        let ktValue = ktIsUser ? null : this._modalValueEdit.value;
                        let skRecord = {
                            KeywordTypeName: ktName,
                            KeywordOperator: ktOperator,
                            ValueIsUserName: ktIsUser,
                            KeywordValue: ktValue
                        };
                        this._skDictionary[this._localIDCounter] = skRecord;
                        this._localIDCounter++;
                        this._editsMade = true;
                        $('#modalPlaceholder').modal('hide');
                    }
                };
                this._editDelete = (event) => {
                    
                    delete this._skDictionary[this._currentRecordId];
                    this._currentRecordId = null;
                    this._editsMade = true;
                    $('#modalPlaceholder').modal('hide');
                };
                this._editCancel = (event) => {
                    
                    this._currentRecordId = null;
                    $('#modalPlaceholder').modal('hide');
                };
                this._editDialogClosed = (event) => {
                    // Tidy up
                    this._globalModalDiv.innerHTML = "";
                    if (this._editsMade) {
                        this._displayKeyList();
                        this._core.Functions.showElement(this._editControls);
                    }
                };
                this._applyEdits = (event) => {
                    
                    this._core.Functions.hideElement(this._editControls);
                    if (this._mode == "None")
                        return;
                    // Update request is same for group or user
                    let request = { SecurityKeywords: [] };
                    Object.keys(this._skDictionary).forEach(recordIndex => {
                        request.SecurityKeywords.push(this._skDictionary[recordIndex]);
                    });
                    if (this._mode == "Group") {
                        this._core.Loader.genericServiceCallWithData(`/SecurityAdmin.svc/rest/ModifyGroupSecurityKeywordsById/${this._currentGroup.Id}`, JSON.stringify(request), this._groupInfoReturned, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        this._core.Loader.genericServiceCallWithData(`/SecurityAdmin.svc/rest/ModifyUserSecurityKeywordsById/${this._currentUser.Id}`, JSON.stringify(request), this._userInfoReturned, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                    this._editsMade = false;
                };
                this._cancelEdits = (event) => {
                    this._core.Functions.hideElement(this._editControls);
                    if (this._mode == "None")
                        return;
                    this._editsMade = false;
                    if (this._mode == "Group") {
                        this.startGroupMode(this._currentGroup.Id);
                    }
                    else {
                        this.startUserMode(this._currentUser.Id);
                    }
                };
                
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.USER_SELECTED:
                        this.startUserMode(context.ActivationID);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.USER_GROUP_SELECTED:
                        this.startGroupMode(context.ActivationID);
                        break;
                }
            }
        }
        SecurityKeywordsWidgetInstanceClass.HtmlData = null;
        Widgets.SecurityKeywordsWidgetInstanceClass = SecurityKeywordsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
